import React from "react";
import About from "../home/About";

const AboutMe = () => {
  return (
    <div>
      <About />
    </div>
  );
};

export default AboutMe;
